// extracted by mini-css-extract-plugin
module.exports = {"slider_slide":"style_slider_slide__h_J6_","slider_row":"style_slider_row__60HZx","desktop_card_horizontal":"style_desktop_card_horizontal__I8STl"};